import { Component, OnInit } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';
import { RepeatFieldConfig } from 'src/app/connector-studio/components/multi-composition/repeat.config';


@Component({
  selector: 'app-section-input-type',
  templateUrl: './section-input-type.component.html',
  styleUrls: ['./section-input-type.component.scss']
})
export class SectionInputTypeComponent extends FieldArrayType<RepeatFieldConfig> implements OnInit {

  constructor() {
    super()
   }

  ngOnInit(): void {
  }

  addItem(type) {
    this.add(null, {type: type.name})
  }
}